import { PAX } from "@pax/telemetry/attributes";
import { useMutation } from "@tanstack/react-query";
import { ThumbsDown, ThumbsUp } from "lucide-react";
import { useState } from "react";
import { api } from "@/lib/api";
import { traceAction } from "@/lib/telemetry";

export function AgentFeedback({
  gameId,
  versionId,
  question = "How is the writing?",
}: {
  gameId: string;
  versionId: string;
  question?: string;
}) {
  const [liked, setLiked] = useState<boolean>();
  const [note, setNote] = useState("");
  const save = useMutation({
    mutationFn: () =>
      traceAction(
        "game.rate_game_master",
        () =>
          api.agents.feedback.set({
            params: { gameId },
            body: { versionId, liked: liked ?? true, note },
          }),
        { [PAX.gameId]: gameId },
      ),
  });
  return (
    <div className="space-y-3">
      <p className="text-xs text-muted-foreground">{question}</p>
      <div className="flex gap-2">
        {[true, false].map(value => (
          <button
            key={String(value)}
            type="button"
            aria-label={value ? "Like the writing" : "Dislike the writing"}
            aria-pressed={liked === value}
            onClick={() => {
              setLiked(value);
              save.reset();
            }}
            className={`rounded-full p-2 ${liked === value ? "bg-foreground/15" : "hover:bg-foreground/5"}`}
          >
            {value ? <ThumbsUp className="size-4" /> : <ThumbsDown className="size-4" />}
          </button>
        ))}
      </div>
      {liked !== undefined && (
        <>
          <textarea
            aria-label="Feedback note"
            placeholder="Anything to add?"
            maxLength={5000}
            value={note}
            onChange={event => setNote(event.target.value)}
            className="w-full rounded-xl bg-foreground/5 p-2 text-sm"
            rows={3}
          />
          <button
            type="button"
            className="rounded-full bg-foreground/10 px-3 py-2 text-xs"
            disabled={save.isPending}
            onClick={() => save.mutate()}
          >
            {save.isSuccess ? "Saved" : "Save feedback"}
          </button>
          {save.error && <p className="text-xs text-destructive">{save.error.message}</p>}
        </>
      )}
    </div>
  );
}
